var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{attrs:{"status":_vm.status,"title":_vm.types[_vm.status].title,"sub-title":_vm.types[_vm.status].desc}})
}
var staticRenderFns = []

export { render, staticRenderFns }